import React from 'react'
import BaseBtn from '@/components/tableDrawer/TableItems/components/tableActions/BaseBtn'
import { Block } from '@/components/crRender'

const ActionBtn = ({icon,tooltipName,onClick,reqAction,isRender}) => {
  return (
    <Block isRender={isRender} tooltipName={tooltipName}    >
        <BaseBtn
            onApply={onClick}
            title={tooltipName}
            className="details-info"
            reqAction={reqAction}
            icon={icon}
        />
    </Block>
  )
}

export default ActionBtn
